import { Channel } from './channel.model';
import { ProgramPoster } from './program-controller/program-poster.model';
import { ProgramGroup } from './program-group.model';
import { ProgramInputPath } from './program-input-path.model';
import { EpgTrim } from './epg-trim.model';

export class Program {
  constructor(
    public broadcastType?: string, //  (string, optional),
    public category?: string, //  (string, optional),
    public channel?: Channel, //   (Channel, optional),
    public country?: string, //         (string, optional),
    public credits?: string, //   (string, optional),
    public description?: string, //   (string, optional),
    public duration?: number, //     (integer, optional),
    public endTime?: number,
    public estimatedStartTime?: number, //    (integer, optional),
    public engDescription?: string,
    public engTitle?: string,
    public epgProgramId?: string, //    (string, optional),
    public externalId?: string,
    public episodeNumber?: string, //    (string, optional),
    public originalTitle?: string, //   (string, optional),
    public postBuffer?: number, //   (integer, optional),
    public posterHorizontalHigh?: string, //    (string, optional),
    public posterHorizontalLow?: string, //      (string, optional),
    public posterLandscapeUrl?: string, //         (string, optional),
    public posterUrl?: string, //   (string, optional),
    public posterVertical?: string, //     (string, optional),
    public ppvEnable?: boolean, //   (boolean, optional),
    public preBuffer?: number, //         (integer, optional),
    public programGroup?: ProgramGroup, //  (ProgramGroup, optional),
    public rating?: string, //   (string, optional),
    public releaseDate?: string, //      (string, optional),
    public seasonNumber?: string, //   (string, optional),
    public seriesId?: string, //   (string, optional),
    public seriesName?: string, //   (string, optional),
    public startTime?: number, //   (integer, optional),
    public status?: string, //    (string, optional) = ['Inserted', 'Updated', 'Deleted', 'None'],
    public title?: string, //   (string, optional),//      (boolean, optional),
    public year?: string, //     (string, optional)
    public posters?: ProgramPoster[],
    public generatedSeriesId?: string,
    public cdrId?: string,
    public day?: string,
    public endHour?: string,
    public startHour?: string,
    public cutvEnabled?: boolean,
    public pltvEnable?: boolean,
    public tstvEnable?: boolean,
    public npvrEnable?: boolean,
    public purchaseBeginTime?: number,
    public purchaseEndTime?: number,
    public startFrameSecond?: number,
    public conflict?: boolean,
    public programInputPaths?: ProgramInputPath[],
    public epgCorrectionStatus?: string,
    public detectionStartTime?: number,
    public detectionEndTime?: number,
    public predictedStartTime?: string,
    public epgTrim?: EpgTrim,
    public keywords?: string,
    public isAdult?: boolean,
    public concurrentWatchCount?: number,
    public visibility?: boolean,
    public trimmed?: boolean,
    public linkToVod?: boolean,
    public hlsPlayUrl?: string,
    public dashPlayUrl?: string,
    public allowedDeviceCodes?: string[]
  ) { }
}
